import GroupBase from "./GroupsBase";

class ConnectivityGroup extends GroupBase {
    constructor() {
        super({
            name: "Connectivity",
            description: "",
        });
    }
}

export default ConnectivityGroup;
